import React, {useEffect, useState} from 'react';
import {addToCart, getItems} from '../api';
import './CatalogPage.css';

const formatPrice = (price) => `${Number(price).toLocaleString('ru-RU')} руб.`;

function CatalogPage() {
    const [items, setItems] = useState([]);
    const [brand, setBrand] = useState('');
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const [sort, setSort] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('success');
    const token = localStorage.getItem('token');

    const buildFilterParams = () => {
        const params = {};

        if (brand) params.brand = brand;
        if (minPrice) params.min_price = minPrice;
        if (maxPrice) params.max_price = maxPrice;
        if (sort) params.sort = sort;

        return params;
    };

    const fetchItems = async (params = buildFilterParams()) => {
        setMessage('');
        const data = await getItems(params);
        setItems(Array.isArray(data) ? data : []);
    };

    useEffect(() => {
        fetchItems({});
        // eslint-disable-next-line
    }, []);

    const handleFilter = (event) => {
        event.preventDefault();
        fetchItems();
    };

    const handleClearFilters = () => {
        setBrand('');
        setMinPrice('');
        setMaxPrice('');
        setSort('');
        fetchItems({});
    };

    const handleAddToCart = async (itemId) => {
        setMessage('');
        if (!token) {
            setMessageType('error');
            setMessage('Пожалуйста, войдите для добавления товаров в корзину.');
            return;
        }

        const res = await addToCart(token, itemId);
        setMessageType('success');
        setMessage(res.message === 'Item added to cart' ? 'Товар добавлен в корзину' : (res.message || 'Товар добавлен в корзину'));
    };

    return (
        <section className="page catalog-page" data-testid="catalog-page">
            <header className="page-header catalog-header">
                <div>
                    <p className="page-kicker">Каталог</p>
                    <h1 className="page-title">Смартфоны и гаджеты</h1>
                    <p className="page-subtitle">
                        Фильтруйте модели по бренду и цене, сравнивайте варианты памяти и добавляйте товары в корзину.
                    </p>
                </div>
                <div className="catalog-count" aria-label={`${items.length} товаров`}>
                    <strong>{items.length}</strong>
                    <span>товаров</span>
                </div>
            </header>

            <form className="catalog-filters panel" onSubmit={handleFilter}>
                <div className="field">
                    <label htmlFor="catalog-brand">Бренд</label>
                    <input
                        id="catalog-brand"
                        type="text"
                        placeholder="Apple, Samsung, Xiaomi"
                        value={brand}
                        onChange={event => setBrand(event.target.value)}
                    />
                </div>

                <div className="field">
                    <label htmlFor="catalog-min-price">Цена от</label>
                    <input
                        id="catalog-min-price"
                        type="number"
                        min="0"
                        placeholder="50 000"
                        value={minPrice}
                        onChange={event => setMinPrice(event.target.value)}
                    />
                </div>

                <div className="field">
                    <label htmlFor="catalog-max-price">Цена до</label>
                    <input
                        id="catalog-max-price"
                        type="number"
                        min="0"
                        placeholder="150 000"
                        value={maxPrice}
                        onChange={event => setMaxPrice(event.target.value)}
                    />
                </div>

                <div className="field">
                    <label htmlFor="catalog-sort">Сортировка</label>
                    <select
                        id="catalog-sort"
                        value={sort}
                        onChange={event => setSort(event.target.value)}
                    >
                        <option value="">Без сортировки</option>
                        <option value="price_asc">Цена по возрастанию</option>
                        <option value="price_desc">Цена по убыванию</option>
                        <option value="name_asc">Название A-Я</option>
                        <option value="name_desc">Название Я-A</option>
                    </select>
                </div>

                <button type="submit" className="btn btn-primary catalog-filter-button">
                    Применить
                </button>
                <button type="button" className="btn btn-muted catalog-clear-button" onClick={handleClearFilters}>
                    Сбросить
                </button>
            </form>

            {message && (
                <div className={`notice notice-${messageType} catalog-message`}>
                    {message}
                </div>
            )}

            {items.length === 0 ? (
                <div className="panel empty-state">
                    Товары не найдены
                </div>
            ) : (
                <div className="product-grid">
                    {items.map(item => (
                        <article data-id="item-card" key={item.id} className="product-card">
                            <div className="product-image-box">
                                {item.image_url ? (
                                    <img className="product-image" src={item.image_url} alt={item.name} />
                                ) : (
                                    <div className="product-image-placeholder">Нет фото</div>
                                )}
                            </div>

                            <div className="product-body">
                                <div className="product-meta">
                                    <span className="product-brand">{item.brand}</span>
                                    {item.category && <span className="product-category">{item.category}</span>}
                                    {item.ram && <span className="product-spec">{item.ram} RAM</span>}
                                </div>

                                <h2 className="product-name">{item.name}</h2>
                                <p className="product-description">{item.description}</p>
                            </div>

                            <div className="product-footer">
                                <div className="product-price">{formatPrice(item.price)}</div>
                                <button
                                    type="button"
                                    className="btn btn-success product-add-button"
                                    onClick={() => handleAddToCart(item.id)}
                                >
                                    В корзину
                                </button>
                            </div>
                        </article>
                    ))}
                </div>
            )}
        </section>
    );
}

export default CatalogPage;
